import PropTypes from 'prop-types'
import { Col, Row, Button, Image as Img } from 'antd'
import { StyledSuperCard } from './styles'
// import { H2 } from 'components/StyleGuide/General'
// import { SB } from 'components/StyleGuide/UIElements/Button'
import accounting from 'accounting'

export const SlicedList = ({ details, redirectLink }) => {
  return (
    <StyledSuperCard bgimage={details.bgImage} midbgimage={details.midBgImage}>
      {details.isNew && (
        <Row>
          <Col span={8} className='img-absolute'>
            <Img
              src='/images/supercard/bg-left-red-new-icon.png'
              alt=''
              preview={false}
            />
          </Col>
        </Row>
      )}
      <Row className='center-vh text-center pizza-card'>
        <Col span={14} className='sc-img'>
          <Img
            className='sc'
            draggable='false'
            src={details.cardImg}
            alt=''
            // layout='fill'
            preview={false}
          />
        </Col>
        <Col span={22} className='mt-2'>
          <h3 style={{ color: 'var(--white)', textAlign: 'center' }}>
            {details.text.card}
          </h3>
          <div className='mt-2' />
          <p style={{ color: 'var(--white)', textAlign: 'center' }}>
            {details.text.description}
          </p>
        </Col>
      </Row>
      <Row className='center-vh pizza-card-middle'>
        {details.mid.price !== ''
          ? (
            <Col span={12}>
              <p>For Only</p>
              <p className='subtitle' style={{ fontSize: '25px' }}>
                {accounting.formatMoney(details.mid.price, '₱ ', 2)}
              </p>
            </Col>
            )
          : (
            <Col style={{ height: 95 }} span={12} />
            )}
      </Row>
      <Row className='pizza-card-footer'>
        <Col span={24}>
          <Button
            type='primary'
            block
            onClick={() =>
              redirectLink(`/supercard/get-one-now/supercard-${details.type}`)
            }
          >
            {details.btnText}
          </Button>
          {/* <Button type='primary' block onClick={() => redirectLink(details.url)}>{details.btnText}</Button> */}
        </Col>
      </Row>
    </StyledSuperCard>
  )
}

SlicedList.propTypes = {
  details: PropTypes.object,
  redirectLink: PropTypes.any
}
